(function (root) {
  'use strict';
  // Calibrated cubic curve in source-image coordinates. Arc-length sampling
  // keeps mixed-size stones packed together on the photographed lower cord.
  function arrange(items, config) {
    const a=config.points, samples=[]; let length=0,prev;
    for(let i=0;i<=1000;i++){
      const t=i/1000,u=1-t;
      const x=u*u*u*a[0]+3*u*u*t*a[2]+3*u*t*t*a[4]+t*t*t*a[6];
      const y=u*u*u*a[1]+3*u*u*t*a[3]+3*u*t*t*a[5]+t*t*t*a[7];
      if(prev)length+=Math.hypot(x-prev.x,y-prev.y);
      const p={x,y,t,length};samples.push(p);prev=p;
    }
    const run=items.reduce((s,m)=>s+m.width,0);
    const mainRun=items.reduce((s,m)=>s+(m.category==='spacer'?0:m.width),0);
    // Nominal fill (L110/S90) is distinct from the permitted maximum run.
    // At nominal use, stones cover the whole lower cord. Additional pieces
    // share that same curve, preserving relative sizes without end gaps.
    const visualRun=Math.max(config.min,run);
    const scale=length/visualRun;
    let cursor=Math.max(0,(visualRun-run)/2);
    const positions=items.map(m=>{
      const target=(cursor+m.width/2)*scale;cursor+=m.width;
      const p=samples.find(p=>p.length>=target)||samples[samples.length-1];
      const t=p.t,u=1-t;
      const dx=3*u*u*(a[2]-a[0])+6*u*t*(a[4]-a[2])+3*t*t*(a[6]-a[4]);
      const dy=3*u*u*(a[3]-a[1])+6*u*t*(a[5]-a[3])+3*t*t*(a[7]-a[5]);
      return {...p,width:m.width,height:m.height,rotation:(m.orient==='tangent'?Math.atan2(dy,dx)*180/Math.PI:0)+(m.rotation||0)};
    });
    return {positions,scale,run,mainRun,fill:Math.min(1,run/config.min),overflow:run>config.capacity||mainRun>config.max,underfill:mainRun<config.min,
      curveLength:length,visualRun};
  }
  const api={arrange};if(typeof module==='object'&&module.exports)module.exports=api;else root.PyraCollarGeometry=api;
})(typeof window==='undefined'?globalThis:window);
